import { apiCall } from "../api";
import AllThatRollupDto from '../../DTOs/WebAppAnalytics/AllThatRollupDto';
import AllThatStudentDto from '../../DTOs/WebAppAnalytics/AllThatStudentDto'; 
import CenterOfHopeSummaryDto from "../../DTOs/WebAppAnalytics/CenterOfHopeSummaryDto";
import CenterOfHopeDetailDto from "../../DTOs/WebAppAnalytics/CenterOfHopeDetailDto";

export const getAllThatRollup = async (dateRangeDto) => {
  let url = 'WebAppAnalytics/AllThatRollup/';
  let response = await apiCall(url, { method: 'POST', body: dateRangeDto });
  return new AllThatRollupDto(response.result);
}

export const getAllThatStudent = async (dateRangeDto) => {
  let url = 'WebAppAnalytics/AllThatStudent/';
  let response = await apiCall(url, { method: 'POST', body: dateRangeDto });
  return new AllThatStudentDto(response.result);
}

export const getCenterOfHopeSummary = async (dateRangeDto) => {
  let url = 'WebAppAnalytics/CenterOfHopeSummary/';
  let response = await apiCall(url, { method: 'POST', body: dateRangeDto });
  return new CenterOfHopeSummaryDto(response.result);
}

export const getCenterOfHopeDetail = async (dateRangeDto) => {
  let url = 'WebAppAnalytics/CenterOfHopeDetail/';
  let response = await apiCall(url, { method: 'POST', body: dateRangeDto });
  return new CenterOfHopeDetailDto(response.result);
}
